import Vue from 'vue';
import Switch from './Switch.vue';

Vue.component('e-switch', Switch);
